import { AutopilotTaskDto } from '@urbanx/agx.activities.client';
import { IconTaskTypes } from '@urbanx/agx.ui-components2';
import TaskDueDateBadge from 'components/tasks/TaskDueDateBadge';
import TaskCompletionConfirmationModal from 'pages/allTasks/TaskModal/TaskCompletionConfirmationModal';
import TaskModalEntry from 'pages/allTasks/TaskModal/TaskModalEntry';
import { useTaskModalState } from 'pages/allTasks/TaskModal/useTaskModalState';
import { JSX, useState } from 'react';
import { getStepsCompletionInfo } from 'utils/tasks';
import ContractComplianceModal from './ContractComplianceModal';

interface ContractComplianceProps {
  campaignId: string;
  task: AutopilotTaskDto;
}

const ContractCompliance = ({ campaignId, task }: ContractComplianceProps) => {
  const modalState = useTaskModalState([task]);
  const modalTask = modalState.modalTasks[0];
  const [showCompletionConfirmation, setShowCompletionConfirmation] = useState(false);
  const { allStepsCompleted, latestCompletedDate } = getStepsCompletionInfo([task]);

  if (!modalTask) throw new Error('Contract Compliance modal task is missing');

  const dueDateValue = allStepsCompleted ? latestCompletedDate : task.dueUtc;
  const dueDate = dueDateValue ? new Date(dueDateValue) : '';

  const badge: JSX.Element = (
    <TaskDueDateBadge
      dueDate={dueDate}
      isCompleted={allStepsCompleted}
      completedDate={latestCompletedDate}
    />
  );

  return (
    <>
      <ContractComplianceModal
        campaignId={campaignId}
        isOpen={modalState.isOpen}
        onClose={modalState.close}
        onCompleteSuccess={() => setShowCompletionConfirmation(true)}
        task={modalTask}
      />
      <TaskModalEntry
        title="Contract Compliance"
        tasks={[task]}
        badge={badge}
        iconType={IconTaskTypes.AgreementCompliance}
        actionText="Complete Compliance Check"
        actionButtonId="completeContractComplianceCheckBtn"
        panelKey="ContractCompliancePanel"
        onAction={modalState.open}
      />
      <TaskCompletionConfirmationModal
        isOpen={showCompletionConfirmation}
        onOpenChange={setShowCompletionConfirmation}
        title="Contract Compliance now complete"
        message="Contract will be emailed to all parties"
      />
    </>
  );
};

export default ContractCompliance;
